const Loading = () => {
    return (
        <div className="flex justify-center items-center h-[50vh] md:h-[60vh] lg:h-[70vh]">
            <div className="animate-pulse">
                <div className="w-12 h-12 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
            </div>
        </div>
    );
};

export default Loading;